export enum Direction {
    Upstream = "Upstream",
    Downstream = "Downstream",
    Net = "Net",
}

export enum DirectionType {
    dir1 = 1,
    dir2 = 2,
    neutral = 3,
}

// naive mapping function. FOG-1472 should make this dynamic according to device configuration.
export const directionTypeKeyToDirection = (
    key: keyof typeof DirectionType,
): Direction | "Indeterminate" | "N/A" => {
    switch (key) {
        case "dir1":
            return Direction.Upstream;
        case "dir2":
            return Direction.Downstream;
        case "neutral":
            return "Indeterminate";
        default:
            return "N/A";
    }
};
